import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "16",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#016FD0",
  d: "M2 0h20c1 0 2 1 2 2v12c0 1-1 2-2 2H2c-1 0-2-1-2-2V2c0-1 1-2 2-2"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M4.257 5.5 2 10.494h2.702l.335-.797h.766l.335.797h2.974v-.608l.265.608h1.539l.265-.62v.62h6.185l.753-.776.704.776L22 10.5l-2.264-2.49L22 5.5h-3.128l-.732.761-.682-.761h-6.73l-.577 1.289L9.559 5.5H6.863v.587l-.3-.587zm.523.71h1.317l1.497 3.385V6.21h1.443l1.157 2.428 1.065-2.428h1.436v3.583h-.873l-.008-2.807-1.273 2.807h-.782L8.48 6.985v2.807H6.68l-.34-.803H4.5l-.34.803h-.963zm8.714 0h3.552l1.087 1.172 1.121-1.173h1.087L18.69 8.01l1.65 1.78h-1.135l-1.086-1.187L16.99 9.79h-3.497zm-8.073.605-.607 1.431h1.213zm8.95.136v.654h1.938v.73h-1.938v.713h2.174l1.01-1.052-.967-1.046z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }